// Returns true when the provided value should be considered "filled".
// Used to determine if optional fields (string/date/others) contain meaningful data.

export const isValueFilled = (value: unknown): boolean => {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (value instanceof Date) return !Number.isNaN(value.getTime());
  return Boolean(value);
};

export default isValueFilled;
